import React, { createContext, useContext, useMemo, ReactNode } from 'react';
import { getCurrentSeason, getSeasonConfig, SeasonType, SeasonConfig } from './seasonConfig';

interface SeasonContextValue {
    season: SeasonType;
    config: SeasonConfig;
}

const SeasonContext = createContext<SeasonContextValue | null>(null);

interface SeasonProviderProps {
    children: ReactNode;
    overrideSeason?: SeasonType;
}

export const SeasonProvider: React.FC<SeasonProviderProps> = ({ children, overrideSeason }) => {
    const value = useMemo(() => {
        const season = overrideSeason ?? getCurrentSeason();
        const config = getSeasonConfig(season);
        return { season, config };
    }, [overrideSeason]);

    return (
        <SeasonContext.Provider value={value}>
            {children}
        </SeasonContext.Provider>
    );
};

export function useSeasonContext(): SeasonContextValue {
    const context = useContext(SeasonContext);
    if (!context) {
        // Fallback if used outside provider
        const season = getCurrentSeason();
        return { season, config: getSeasonConfig(season) };
    }
    return context;
}
